import { render, staticRenderFns } from "./LegalMentions.vue?vue&type=template&id=10c21ace&scoped=true"
import script from "./LegalMentions.vue?vue&type=script&lang=js"
export * from "./LegalMentions.vue?vue&type=script&lang=js"
import style0 from "./LegalMentions.vue?vue&type=style&index=0&id=10c21ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c21ace",
  null
  
)

export default component.exports